import axios from '../utils/setupAxiosAuth';
import { getApiBaseUrl } from '../utils/apiBaseUrl';
import API_ROUTES from '../routes/routes';

const authHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem('user_authToken')}`,
});

export interface InquiryInboxThread {
  conversation_key: string;
  contact_phone: string | null;
  inquiry_id: number | null;
  seller_id: number | null;
  last_body: string | null;
  last_sent_at: string | null;
  last_message_id: string | null;
  last_direction?: 'inbound' | 'outbound';
  needs_reply?: boolean;
}

export interface InquiryWhatsAppMessage {
  id: number;
  provider_message_id: string;
  direction: 'inbound' | 'outbound';
  contact_phone: string | null;
  body: string | null;
  inquiry_id: number | null;
  seller_id: number | null;
  status: string | null;
  replied_by?: string | null;
  sent_at: string;
}

const base = () => `${getApiBaseUrl()}${API_ROUTES.inquiryWorkflow}`;

export const fetchInquiryInboxThreads = async (params: Record<string, string | number>) => {
  const response = await axios.get(`${base()}/inquiry-inbox/threads`, {
    headers: authHeaders(),
    params,
  });
  return {
    data: response.data as InquiryInboxThread[],
    total: parseInt(response.headers['x-total-count'] || '0', 10),
  };
};

export const fetchInquiryInboxThread = async (threadKey: string) => {
  const encoded = encodeURIComponent(threadKey);
  const response = await axios.get(`${base()}/inquiry-inbox/threads/${encoded}/messages`, {
    headers: authHeaders(),
  });
  return response.data as { conversation_key: string; messages: InquiryWhatsAppMessage[] };
};

export const pollPlivoInquiryReplies = async (days = 1) => {
  const response = await axios.post(
    `${base()}/poll-plivo`,
    { days },
    { headers: authHeaders() }
  );
  return response.data;
};

export const sendInquiryInboxReply = async (threadKey: string, body: string) => {
  const encoded = encodeURIComponent(threadKey);
  const response = await axios.post(
    `${base()}/inquiry-inbox/threads/${encoded}/reply`,
    { body },
    { headers: authHeaders() }
  );
  return response.data as InquiryWhatsAppMessage;
};
